module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "testimonials"
  }, [_c('bacon', {
    attrs: {
      "title": "Testimonials"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "slider"
  }, [_c('transition-group', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, _vm._l((_vm.testimonials), function(item, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i == _vm.selected),
        expression: "i == selected"
      }],
      key: item.name,
      staticClass: "slide"
    }, [_c('h3', {
      staticClass: "two-line-heading"
    }, [_vm._v(_vm._s(item.name) + "\n            "), _c('span', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('p', {
      staticClass: "description"
    }, [_vm._v(_vm._s(item.description))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, _vm._l((_vm.testimonials), function(item, i) {
    return (_vm.showDots) ? _c('span', {
      staticClass: "dot",
      class: {
        active: i == _vm.selected
      },
      on: {
        "click": function($event) {
          _vm.select(i)
        }
      }
    }) : _vm._e()
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-287a27fc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/testimonials.vue
// module id = 155
// module chunks = 0